// Module
var code = "<div ng-hide=\"!vm.loading\" style=\"position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -24px 0 0 -24px;\n    width: 50px;\"> <img src=\"/img/loader.gif\" alt=\"\"/> </div> ";
// Exports
module.exports = code;